import ComponentHeader from '../main/ComponentHeader';
import GruntComponents from '../components';
import {Box, InputGroup, InputLeftElement, Input, Spacer, Stack,  Button, RadioGroup,Radio,
    Drawer, DrawerOverlay, DrawerContent, DrawerHeader, DrawerBody, useToast, SkeletonCircle, SkeletonText
   } from '@chakra-ui/react';
import { SearchIcon, SmallAddIcon } from '@chakra-ui/icons';
import { loggedOper as lp } from '../../util/grunt';
import { useState, useEffect } from 'react';
import Odlazak from '../odlazak/Odlazak';
import OdlasciTable from '../odlazak/OdlasciTable';
import { addOdlazak,editIzlucenjeVerifikacija,deleteOdlazak,editOdlazak,getOdlasciFilter} from '../../util/apiMigracija';

import IzlucenjaFilter from './IzlucenjaFilter';

export default function Izlucenja({onClosePress,size='xs'}) {

  const [state,setState]=useState({newOdlazak:false,editOdlazakMigracijaId:0,editMigracijaTipSifra:"OUGIN",viewOdlazakMigracijaId:0,viewMigracijaTipSifra:"OUGIN",toggleShowData:false})
  const [odlasci,setOdlasci]=useState([]);
  const [prikaz, setPrikaz] = useState({orderbycol:"datum",orderby:"desc",odlasciprikaz:[],rowsperpage:20,currpage:1});
  const [filter,setFilter]=useState({filterStatus:"off",showFilter:false,filterData:{odlazaktipovi:["OUGIN"],datumod:(new Date().getFullYear()-1).toString()+'-01-01',datumdo:new Date().toISOString().split("T")[0]},verificiran:true})
  const [isloading,setIsLoading]=useState(false);
  const toast=useToast();
  
  //
  const fetchOdlasci=async ()=>{
    let res;
    try {
            setIsLoading(true);
            res=await getOdlasciFilter(filter.filterData);
  
        
        if (res.status===200) {
            setOdlasci(res.res);
            setPrikaz({...prikaz,odlasciprikaz:res.res}); 
        } else {
            throw new Error(res.message);
        }
    } catch (error) {
        toast({
            title:"Greška kod dohvata podataka.",
            status:"error",
            description:error.message,
            isClosable:true,
            duration:2000,
            position:"top-right",
        });
    } finally {
      setIsLoading(false);
    }
}

useEffect(() => {
  fetchOdlasci();
}, [filter.filterData,state.toggleShowData])

  //
  const btnNew=()=>{
    if (lp.uloga!=="r") {
        return (
            <Button rightIcon={<SmallAddIcon/>} colorScheme={'grunt2'} variant={'outline'} size={'xs'} onClick={()=>{setState({...state,newOdlazak:true})}}>Dodaj</Button>
            )
    } else {
        return (
            <></>
            )
    }
  }

const deleteSelectedOdlazak=async(odlmigracijaid)=>{
  try {
    const res=await deleteOdlazak({migracijaid:odlmigracijaid});
    if (res.status===200) {
      setState({...state,newOdlazak:"",editOdlazakMigracijaId:0,editMigracijaTipSifra:"",toggleShowData:!state.toggleShowData,viewDolazakMigracijaId:0});  
      toast({
        title:"Odlazak obrisan.",
        status:"success",
        isClosable:true,
        duration:1500,
        position:"top-right",
    });
    } else {
      throw new Error(res.message);
    }
    
  } catch (error) {
    toast({
      title:"Greška kod unosa",
      status:"error",
      description:error.message,
      isClosable:true,
      duration:2000,
      position:"top-right",
  });
  }
    
}


  const saveOdlazak= async (_odldata)=>{
    try {
      let res;
      let _govedaid=[];
      _odldata.goveda.forEach(gov=>_govedaid.push(gov.govedo_id));
      if (state.editOdlazakMigracijaId===0) {
          //add new
          res=await addOdlazak({dokumenttipid:_odldata.dokument_tip_id,migracijatipsifra:"OUGIN",knjigaid:_odldata.knjiga_id,
            datum:_odldata.datum,migracijaposjednikid:0,migracijaknjigaid:0,uktezina:_odldata.uktezina,ijr:_odldata.ijr,
          dokumentbroj:_odldata.dokument_broj,govedaid:_govedaid});
      } else {
          //edit
           
           res=await editOdlazak({omigracijaid:state.editOdlazakMigracijaId,dokumenttipid:_odldata.dokument_tip_id,migracijatipsifra:"OUGIN",knjigaid:_odldata.knjiga_id,
            datum:_odldata.datum,migracijaposjednikid:0,migracijaknjigaid:0,uktezina:_odldata.uktezina,ijr:_odldata.ijr,
          dokumentbroj:_odldata.dokument_broj,govedaid:_govedaid});
  
      }
        
       //res=await addOdlazak({dokumenttipid,migracijatipsifra,knjigaid,datum,migracijaposjednikid,migracijaknjigaid,uktezina,ijr,dokumentbroj,govedaid:goveda});
      
       
      
      if (res.status===200) {
  
          //setPrikaz({...prikaz,showKlaonica:false,selectedKlaonica:{},fetchklaonice:prikaz.fetchklaonice+1})
          setState({...state,newOdlazak:false,editOdlazakMigracijaId:0,toggleShowData:!state.toggleShowData,viewDolazakMigracijaId:0});
          toast({
              title:"Podatak spremljen",
              status:"success",
              isClosable:true,
              duration:1500,
              position:"top-right",
          });
      } else {
         
              throw new Error(res.message);
         
      }
  } catch (ex) {
  toast({
      title:"Greška kod unosa",
      status:"error",
      description:ex.message,
      isClosable:true,
      duration:2000,
      position:"top-right",
  });
  }
  }

  const getIzlucenjeControl=()=>{
    if (state.newOdlazak || state.editOdlazakMigracijaId!==0 || state.viewOdlazakMigracijaId!==0) {
      const _readonly=state.viewOdlazakMigracijaId!==0;
      let _migrid=state.editOdlazakMigracijaId;
      if (state.viewOdlazakMigracijaId!==0) {
        _migrid=state.viewOdlazakMigracijaId;
      }
      return (
        <Drawer placement='right' size={'xl'} isOpen={true}>
        <DrawerOverlay/>
        <DrawerContent roundedTopLeft={'md'}>
            <DrawerHeader pt='5px' roundedTopLeft={'md'} h={'40px'} color={'white'}  bg={'grunt2.700'}>
                Izlučenje
            </DrawerHeader>
            <DrawerBody>
                    <Odlazak odlazak_tip_sifra={"OUGIN"} onClose={closeOdlazakControl} onSave={saveOdlazak} onDelete={deleteSelectedOdlazak} readonly={_readonly} newOdlazak={state.newOdlazak} odlazakMigracijaId={_migrid}/>
            </DrawerBody>
        </DrawerContent>
        </Drawer>
    )
    }     
  }


const closeOdlazakControl=()=>{
  setState({newOdlazak:false,editOdlazakMigracijaId:0,viewOdlazakMigracijaId:0,toggleShowData:false});
}

const setVerificiran= async (migracijaid,verificiran)=>{
  try {
    const res= await editIzlucenjeVerifikacija(migracijaid,verificiran);
    if (res.status===200) {
      setState({...state,toggleShowData:!state.toggleShowData});
      toast({
        title:"Verifikacija promijenjena.",
        status:"success",
        isClosable:true,
        duration:1500,
        position:"top-right",
    });      
    } else {
      throw new Error(res.message);
    }
  } catch (ex) {
    toast({
      title:"Greška kod promjene podataka.",
      status:"error",
      description:ex.message,
      isClosable:true,
      duration:2000,
      position:"top-right",
  });
  }
}

const getOdlasciTable=()=>{
  if (isloading) {
    return (
      <Box>
        <SkeletonCircle size='10' />
        <SkeletonText mt='4' noOfLines={30} spacing='3' skeletonHeight='2' />
      </Box>
    )
  } else {
    return (<OdlasciTable odlasci={prikaz.odlasciprikaz} onEditOdlazak={oneditOdlazak} onViewOdlazak={onviewOdlazak} onViewDolazak={onViewDolazak} izlucenje={true} onVerificiraj={setVerificiran} />) 
  }
  
}

const oneditOdlazak=(migracijaid,migracijatipsifra)=>{
  setState({...state,newOdlazak:"",editOdlazakMigracijaId:migracijaid,editMigracijaTipSifra:"OUGIN",viewDolazakMigracijaId:0});
  //setState({editDolazakMigracijaId:migracijaid,editMigracijaTipSifra:migracijatipsifra});
}

const onviewOdlazak=(migracijaid,migracijatipsifra)=>{
  setState({...state,newOdlazak:"",viewOdlazakMigracijaId:migracijaid,viewMigracijaTipSifra:migracijatipsifra,viewDolazakMigracijaId:0});
}
const onViewDolazak=(migracijaid)=>{
  
}



const onCloseFilter=()=>{

  setFilter({...filter,showFilter:false});
}

const onSetFilterOdlazaka=(f)=>{
  setFilter({...filter,filterData:f,filterStatus:"on",showFilter:false});
}

const getFilterControl=()=>{
  if (filter.showFilter) {
    return (
      <Drawer placement='right' size={'xl'} isOpen={true}>
      <DrawerOverlay/>
      <DrawerContent roundedTopLeft={'md'}>
          <DrawerHeader pt='5px' roundedTopLeft={'md'} h={'40px'} color={'white'}  bg={'grunt2.700'}>
              Napredno filtriranje odlazak
          </DrawerHeader>
          <DrawerBody p='0.5rem'>
                  <IzlucenjaFilter onSetFilter={onSetFilterOdlazaka} onClose={onCloseFilter} />
          </DrawerBody>
      </DrawerContent>
      </Drawer>
  )
  }
}

const FilterData=(filter)=>{
  const _val=filter.target.value.toLowerCase();
  let _o=odlasci.filter((odl)=>{
      return (odl.knjiga.toLowerCase().includes(_val) || odl.migracija_tip.toLowerCase().includes(_val) || odl.odlposjednik.toLowerCase().includes(_val) || odl.dokument_broj.toLowerCase().includes(_val) || odl.dolposjednik.toLowerCase().includes(_val) || odl.dolknjiga.toLowerCase().includes(_val));
  });
  setPrikaz({...prikaz,odlasciprikaz:_o,currpage:1}); 
}
//

const onRadioButtonChange=(val)=>{
    
      setFilter({...filter,filterData:{...filter.filterData,verificiran:val.toLowerCase()==='true'}});
    
}
//

  return (
   // <Box h={'92vh'} key='odlasci_component' pl='0.5rem' pr={'0.5rem'}>
   <Box display={'flex'} flexDir={'column'} h={'100%'} borderColor={'silver'} borderBottomRightRadius={'md'} borderWidth={'0.5px'} key='drzave_component' pl={'0.5rem'} pr={'0.5rem'}>
        <ComponentHeader onClosePress={onClosePress} component={GruntComponents.Izlucenja}/>
        <Box  display={'flex'} alignItems={'center'} mb={'0.5rem'}>
                  <Box mr={'0.5rem'}>
                    <InputGroup size={size} w='20rem'>
                        <InputLeftElement pointerEvents={'none'} children={<SearchIcon/>}/>
                        <Input focusBorderColor='grunt2.400' placeholder='Filter' maxLength={'20'} onChange={FilterData} />
                    </InputGroup>
                    </Box>
                    <RadioGroup fontSize={size} size={'sm'} onChange={onRadioButtonChange} defaultValue={'true'} ml='2rem'>
                        <Stack direction='row'>
                            <Radio value='true'>Verificirana</Radio>
                            <Radio value='false'>Neverificirana</Radio>
                            
                        </Stack>
                    </RadioGroup>
                    <Spacer/>
                    <Stack direction={'row'} spacing={'1rem'} mr={'1rem'}>
                    {btnNew()}    
                    </Stack>
        </Box>
        {getOdlasciTable()}
        {getIzlucenjeControl()}
        
        {getFilterControl()}
    </Box>
  )
}
